import React from 'react';

import { Text } from '~/components/core';
import TextField from '~/components/core/Molecules/Fields/TextField';
import Switch from '~/components/ui/atoms/Switch';

interface RolesSearchProps {
  onSearchTermChanged: (term: string) => void;
  onShowOnlyCustomRolesChanged: (show: boolean) => void;
}

const RolesFilter: React.FC<RolesSearchProps> = ({ onSearchTermChanged, onShowOnlyCustomRolesChanged }) => {
  return (
    <div className="my-20 grid grid-cols-3 gap-32">
      <TextField label="Search Roles" onChange={onSearchTermChanged} />
      <span className="flex items-center">
        <Switch onChange={(e) => onShowOnlyCustomRolesChanged(e.target.checked)} />{' '}
        <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR}>
          Show only custom roles
        </Text>
      </span>
    </div>
  );
};

export default RolesFilter;
